"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4547],{

/***/ 27078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* reexport */ ImageGallery; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./src/@next/components/organisms/Overlay/index.ts + 2 modules
var Overlay = __webpack_require__(98720);
// EXTERNAL MODULE: ./src/images/chevron_left.svg
var chevron_left = __webpack_require__(36811);
// EXTERNAL MODULE: ./src/images/chevron_right.svg
var chevron_right = __webpack_require__(81111);
// EXTERNAL MODULE: ./src/images/x.svg
var x = __webpack_require__(63232);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/organisms/ImageGallery/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  font-size: ",
        ";\n  line-height: 1em;\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: scale(0.8);\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: scale(0.5);\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 50%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  * {\n    color: ",
        ";\n  }\n\n  svg {\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    left: -20px;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  right: -20px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 65vw;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: initial;\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: 500px;\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  ",
        "\n  ",
        "\n  img {\n    display: block;\n    margin: 0 auto;\n    max-height: 700px;\n    max-width: 100%;\n    ",
        "\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}

var Modal = globalStyles/* styled.div */.zo.div(_templateObject());
var Header = globalStyles/* styled.div */.zo.div(_templateObject1(), function(props) {
    return "1.1rem ".concat(props.theme.spacing.gutter);
});
var CloseImg = globalStyles/* styled.div */.zo.div(_templateObject2());
var Counter = globalStyles/* styled.div */.zo.div(_templateObject3(), function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.baseFontColorOpacityLight;
});
var Navigation = globalStyles/* styled.div */.zo.div(_templateObject6(), function(props) {
    return props.theme.colors.white;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject4()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject5()));
var Previous = globalStyles/* styled.button */.zo.button(_templateObject8(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject7()));
var Next = globalStyles/* styled.button */.zo.button(_templateObject10(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject9()));
var Preview = globalStyles/* styled.div */.zo.div(_templateObject14(), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject11()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject12()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject13()));

;// CONCATENATED MODULE: ./src/@next/components/organisms/ImageGallery/ImageGallery.tsx









var ImageGallery = function(param) {
    var hide = param.hide, show = param.show, target = param.target, images = param.images, index = param.index;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(index), 2), imageIndex = ref[0], setImageIndex = ref[1];
    react.useEffect(function() {
        if (imageIndex >= images.length) {
            setImageIndex(0);
        }
    }, [
        images
    ]);
    var nextSlide = function() {
        if (images && imageIndex + 1 < images.length) {
            setImageIndex(imageIndex + 1);
        } else {
            setImageIndex(0);
        }
    };
    var prevSlide = function() {
        if (images && imageIndex <= 0) {
            setImageIndex(images.length - 1);
        } else {
            setImageIndex(imageIndex - 1);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        position: "fit",
        show: show,
        hide: hide,
        target: target,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                    divider: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Counter, {
                            children: [
                                imageIndex + 1,
                                "/",
                                images && images.length
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseImg, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                                src: x,
                                onClick: hide
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview, {
                    children: images && images.length > 0 && imageIndex < images.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: images ? images[imageIndex].url : "",
                        alt: images ? images[imageIndex].alt : ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navigation, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Previous, {
                            type: "button",
                            onClick: prevSlide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                                src: chevron_left
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Next, {
                            type: "button",
                            onClick: nextSlide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                                src: chevron_right
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/ImageGallery/index.ts



/***/ }),

/***/ 10273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ ProductReviews; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
// EXTERNAL MODULE: ./src/core/config.ts + 15 modules
var config = __webpack_require__(42443);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./src/@next/components/molecules/CardHeader/styles.ts
var styles = __webpack_require__(71013);
// EXTERNAL MODULE: ./src/@next/components/organisms/Overlay/index.ts + 2 modules
var Overlay = __webpack_require__(98720);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/molecules/ReviewItem/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: auto;\n    width: 90vw;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 2em;\n  background: #fdfdfe;\n  height: 100%;\n  max-width: 400px;\n  ",
        "\n\n  &:hover {\n    background: #ffffff;\n    box-shadow: 0px 14px 44px rgba(0, 0, 0, 0.07);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --percent: calc(var(--rating) / 5 * 100%);\n  display: inline-block;\n  font-size: ",
        ";\n  font-family: 'Segoe UI';\n  line-height: 1;\n  &::before {\n    content: '★★★★★';\n    letter-spacing: 3px;\n    background: linear-gradient(\n      90deg,\n      #c34c3e var(--percent),\n      #c78881 var(--percent)\n    );\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 3px;\n  color: rgba(131, 144, 152, 0.5);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1em;\n  display: flex;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 12px;\n    max-height: 46px;\n    max-width: 46px;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 19px;\n  max-height: 56px;\n  max-width: 56px;\n  ",
        "\n\n  img {\n    width: 100%;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  margin-top: 1rem;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1rem;\n  font-size: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n  font-size: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 1rem;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px auto;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  align-items: center;\n  justify-content: center;\n  background: #2c2c2c;\n  opacity: 0.6;\n  color: #ffffff;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-height: 480px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  cursor: pointer;\n  border-radius: 6px;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    max-height: 480px;\n  }\n\n  &:hover {\n    ",
        " {\n      display: flex;\n    }\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject()));
var Stars = globalStyles/* styled.div */.zo.div(_templateObject2(), function(props) {
    return props.theme.typography.h4FontSize;
});
var Author = globalStyles/* styled.div */.zo.div(_templateObject3());
var AuthorName = globalStyles/* styled.div */.zo.div(_templateObject4(), function(props) {
    return props.theme.typography.baseFontSize;
});
var AuthorDate = globalStyles/* styled.div */.zo.div(_templateObject5());
var Extra = globalStyles/* styled.div */.zo.div(_templateObject6());
var Avatar = globalStyles/* styled.div */.zo.div(_templateObject8(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject7()));
var Description = globalStyles/* styled.div */.zo.div(_templateObject9(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
});
var Title = globalStyles/* styled.div */.zo.div(_templateObject10(), function(props) {
    return props.theme.typography.h5FontSize;
});
var ReadMoreButton = globalStyles/* styled.button */.zo.button(_templateObject11(), function(props) {
    return props.theme.typography.baseFontSize;
});
var Rating = globalStyles/* styled.div */.zo.div(_templateObject12());
var Header = globalStyles/* styled.div */.zo.div(_templateObject13());
var Column = globalStyles/* styled.div */.zo.div(_templateObject14());
var ImagesList = globalStyles/* styled.div */.zo.div(_templateObject15());
var ImageCount = globalStyles/* styled.div */.zo.div(_templateObject16());
var ImagePlaceholder = globalStyles/* styled.div */.zo.div(_templateObject17());
var ImageGalleryButton = globalStyles/* styled.button */.zo.button(_templateObject18(), ImageCount);

;// CONCATENATED MODULE: ./src/@next/components/molecules/ReviewItem/RatingStars.tsx



var RatingStars = function(param) {
    var rating = param.rating;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars, {
        style: (0,_define_property/* default */.Z)({}, "--rating", rating.toString())
    });
};

// EXTERNAL MODULE: ./src/images/x.svg
var x = __webpack_require__(63232);
;// CONCATENATED MODULE: ./src/@next/components/overlays/ReviewItem/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height:100%;\n    width: 100%;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: #ffffff;\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n  }\n  &::-webkit-scrollbar {\n    width: 4px;\n    background-color: #f5f5f5;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #808080;\n  }\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: ",
        ";\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: calc(",
        " * 2);\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 270px;\n    width: 270px;\n    padding: 28px 42px 32px;\n  "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 366px;\n  width: 366px;\n  background-color: ",
        ";\n  display: flex;\n  padding: 62px;\n  img {\n    mix-blend-mode: darken;\n    height: 100%;\n    margin: auto;\n  }\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    overflow: auto;\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  ",
        "\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n  opacity: 0.6;\n  color: #ffffff;\n  border-radius: 6px;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-right: 24px;\n    "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 150px;\n      max-height: 200px;\n    "
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  &:not(:last-child) {\n    margin-right: 30px;\n    ",
        "\n  }\n\n  img {\n    max-width: 190px;\n    max-height: 260px;\n    border-radius: 6px;\n    ",
        "\n  }\n\n  &:hover {\n    ",
        " {\n      display: flex;\n    }\n  }\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 17px;\n    font-size: 14px;\n    line-height: 160%;\n  "
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n  ",
        "\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: rgba(131, 144, 152, 0.5);\n  margin-right: 5px;\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 40px;\n  "
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 60px;\n  ",
        "\n"
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 14px;\n    line-height: 110%;\n  "
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 17px;\n  font-size: ",
        ";\n  line-height: 110%;\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 30px;\n    max-width: 504px;\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 40px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 160%;\n  max-width: 630px;\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 30px;\n  "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 40px;\n  display: flex;\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 40px auto 0;\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding: 9px;\n  margin: 54px auto 0;\n  font-size: ",
        ";\n  line-height: 16px;\n  border-bottom: 2px solid #c34c3e;\n  cursor: pointer;\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 12px;\n    max-height: 46px;\n    max-width: 46px;\n  "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 19px;\n  max-height: 56px;\n  max-width: 56px;\n  ",
        "\n\n  img {\n    width: 100%;\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: ",
        ";\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  margin-top: 3px;\n  color: rgba(131, 144, 152, 0.5);\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}

var Modal = globalStyles/* styled.div */.zo.div(styles_templateObject1(), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject()));
var Content = globalStyles/* styled.div */.zo.div(styles_templateObject3(), function(param) {
    var spacing = param.theme.spacing;
    return spacing.gutter;
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject2(), function(param) {
    var spacing = param.theme.spacing;
    return spacing.gutter;
}));
var ProductImage = globalStyles/* styled.div */.zo.div(styles_templateObject5(), function(param) {
    var colors = param.theme.colors;
    return colors.redLight;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject4()));
var Gallery = globalStyles/* styled.div */.zo.div(styles_templateObject7(), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject6()));
var styles_ImageCount = globalStyles/* styled.div */.zo.div(styles_templateObject8(), function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
});
var ImageButton = globalStyles/* styled.button */.zo.button(styles_templateObject11(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject9()), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject10()), styles_ImageCount);
var Category = globalStyles/* styled.div */.zo.div(styles_templateObject13(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject12()));
var CategoryTitle = globalStyles/* styled.span */.zo.span(styles_templateObject14());
var CategoryName = globalStyles/* styled.span */.zo.span(styles_templateObject15());
var Rate = globalStyles/* styled.div */.zo.div(styles_templateObject17(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject16()));
var styles_Title = globalStyles/* styled.div */.zo.div(_templateObject19(), function(param) {
    var theme = param.theme;
    return theme.typography.h4FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject18()));
var styles_Description = globalStyles/* styled.div */.zo.div(_templateObject21(), function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var theme = param.theme;
    return theme.typography.baseFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject20()));
var styles_Extra = globalStyles/* styled.div */.zo.div(_templateObject23(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject22()));
var CloseButton = globalStyles/* styled.button */.zo.button(_templateObject25(), function(param) {
    var theme = param.theme;
    return theme.typography.h5FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject24()));
var styles_Avatar = globalStyles/* styled.div */.zo.div(_templateObject27(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject26()));
var styles_Author = globalStyles/* styled.div */.zo.div(_templateObject28());
var styles_AuthorName = globalStyles/* styled.div */.zo.div(_templateObject29(), function(param) {
    var theme = param.theme;
    return theme.typography.baseFontSize;
}, function(param) {
    var theme = param.theme;
    return theme.typography.baseFontSize;
});
var styles_AuthorDate = globalStyles/* styled.div */.zo.div(_templateObject30(), function(param) {
    var typography = param.theme.typography;
    return typography.thinFontFamily;
});

;// CONCATENATED MODULE: ./src/@next/components/overlays/ReviewItem/ReviewItem.tsx










var ReviewItem = function(param) {
    var item = param.item, showGallery = param.showGallery;
    var intl = (0,useIntl/* default */.Z)();
    var modal = (0,esm/* useModal */.dd)();
    var gallerySliced = item.images.slice(0, 4);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        position: "fit",
        show: modal.visible,
        hide: modal.remove,
        transparent: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Header */.h4, {
                    divider: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* CloseImg */.Fl, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                            src: x,
                            onClick: modal.remove
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery, {
                            children: gallerySliced && gallerySliced.map(function(img, i, gallery) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageButton, {
                                    type: "button",
                                    onClick: function() {
                                        return showGallery(gallery, i);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: img.url,
                                            alt: img.alt
                                        }),
                                        gallerySliced.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_ImageCount, {
                                            children: [
                                                item.images.length - 1,
                                                "+"
                                            ]
                                        })
                                    ]
                                }, i);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Rate, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStars, {
                                rating: item.rating
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Title, {
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Description, {
                            children: item.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Extra, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Avatar, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: config/* REVIEW_AVATARS.get */.OM.get(item.avatar),
                                        alt: "avatar"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Author, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_AuthorName, {
                                            children: item.fullName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_AuthorDate, {
                                            children: intl.formatDate(item.publicationDate)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ReviewItem_ReviewItem = (esm/* default.create */.ZP.create(ReviewItem));

;// CONCATENATED MODULE: ./src/@next/components/overlays/ReviewItem/index.tsx


;// CONCATENATED MODULE: ./src/images/review-placeholder.png
/* harmony default export */ var review_placeholder = ({"src":"/_next/static/media/review-placeholder.edf2763a.png","height":260,"width":190,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAElBMVEXv6Or07/Hr5ebm3+H8+vrY0tTjbdehAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKUlEQVR4nDXKMQ4AMAyDQIzT/3+5SqWysBwJIFGFnCMQOxPSvyxrn9m8CTAAUgUfdcUAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
;// CONCATENATED MODULE: ./src/@next/components/molecules/ReviewItem/ReviewItem.tsx










var DESC_LENGHT_CONST = 100;
var ReviewItem_ReviewItem_ReviewItem = function(param) {
    var item = param.item, showGallery = param.showGallery;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "ReviewItem",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImagesList, {
                children: [
                    (item === null || item === void 0 ? void 0 : item.images.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageGalleryButton, {
                        type: "button",
                        onClick: function() {
                            return showGallery(item.images, 0);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: item.images[0].url,
                                alt: item.images[0].alt,
                                width: "300",
                                height: "400"
                            }),
                            item.images.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageCount, {
                                children: [
                                    item.images.length - 1,
                                    "+"
                                ]
                            })
                        ]
                    }),
                    (item === null || item === void 0 ? void 0 : item.images.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlaceholder, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: review_placeholder.src,
                            alt: "placeholder",
                            width: "300",
                            height: "400"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStars, {
                                    rating: item.rating
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                children: (item === null || item === void 0 ? void 0 : item.description.length) > DESC_LENGHT_CONST ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                item.description.slice(0, DESC_LENGHT_CONST),
                                                "..."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMoreButton, {
                                            type: "button",
                                            onClick: function() {
                                                esm/* default.show */.ZP.show(ReviewItem_ReviewItem, {
                                                    item: item,
                                                    showGallery: showGallery
                                                });
                                            },
                                            children: intl.formatMessage(src_intl/* commonMessages.ReadMore */.i4.ReadMore)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: item.description
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Extra, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: config/* REVIEW_AVATARS.get */.OM.get(item === null || item === void 0 ? void 0 : item.avatar),
                                    width: "56",
                                    height: "56",
                                    alt: "avatar",
                                    style: {
                                        maxWidth: "100%",
                                        height: "100%"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Author, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorName, {
                                        children: item === null || item === void 0 ? void 0 : item.fullName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorDate, {
                                        children: intl.formatDate(item.publicationDate)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/ReviewItem/index.tsx


// EXTERNAL MODULE: ./src/@next/components/organisms/ImageGallery/index.ts + 2 modules
var ImageGallery = __webpack_require__(27078);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
// EXTERNAL MODULE: ./src/images/chevron_left.svg
var chevron_left = __webpack_require__(36811);
// EXTERNAL MODULE: ./src/images/chevron_right.svg
var chevron_right = __webpack_require__(81111);
;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductReviews/styles.ts

function ProductReviews_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-size: contain !important;\n      width: 42px;\n      height: 42px;\n    "
    ]);
    ProductReviews_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      top: 46%;\n      border-radius: 50%;\n      width: 33px;\n      height: 33px;\n      transform: translate3d(0, 0, 0);\n      box-shadow: 0px 0px 10px 0px #dfdfdf;\n    "
    ]);
    ProductReviews_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-arrow {\n    position: absolute;\n    width: 56px;\n    height: 56px;\n    text-indent: -999999px;\n    top: 50%;\n    box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.08);\n    border-radius: 50%;\n    z-index: 1;\n    ",
        "\n    ",
        "\n    &:before {\n      content: none;\n    }\n  }\n"
    ]);
    ProductReviews_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: 45px;\n    "
    ]);
    ProductReviews_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: 10px;\n    "
    ]);
    ProductReviews_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-prev {\n    background: url(",
        ") no-repeat center !important;\n    left: 55px;\n    ",
        "\n    ",
        "\n    &.slick-disabled {\n      opacity: 0.5;\n      cursor: default;\n    }\n  }\n"
    ]);
    ProductReviews_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: 45px;\n    "
    ]);
    ProductReviews_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: 10px;\n    "
    ]);
    ProductReviews_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-next {\n    background: url(",
        ") no-repeat center !important;\n    right: 55px;\n    ",
        "\n    ",
        "\n    &.slick-disabled {\n      opacity: 0.5;\n      cursor: default;\n    }\n  }\n"
    ]);
    ProductReviews_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: -10%;\n    "
    ]);
    ProductReviews_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: 0;\n    "
    ]);
    ProductReviews_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-track {\n    display: flex;\n    left: -20%;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    ProductReviews_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-slide {\n    display: flex;\n    height: auto;\n    & > div {\n      width: 100%;\n    }\n  }\n"
    ]);
    ProductReviews_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 100%;\n      padding: 0;\n    "
    ]);
    ProductReviews_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      overflow: visible;\n      padding: 0 0px 0 52px !important;\n    "
    ]);
    ProductReviews_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-list {\n    overflow: hidden;\n    width: 100%;\n    height: auto !important;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    ProductReviews_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: hsl(210, 12%, 97%);\n  overflow: hidden;\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ProductReviews_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2em 2em;\n"
    ]);
    ProductReviews_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function ProductReviews_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n  "
    ]);
    ProductReviews_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  ",
        "\n"
    ]);
    styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 2rem;\n"
    ]);
    styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // margin: 0;\n  position: relative;\n"
    ]);
    styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-right: 20px;\n  "
    ]);
    styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-right: 8px;\n    height: auto;\n  "
    ]);
    styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function styles_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 35px;\n  height: 100%;\n  width: 100%;\n  outline: none;\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function styles_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    letter-spacing: -0.5px;\n  "
    ]);
    styles_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function styles_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 100%;\n  color: ",
        ";\n  ",
        "\n\n  &:after {\n    content: '';\n    display: block;\n    height: 2px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ",
        ";\n  }\n"
    ]);
    styles_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}






var slickArrow = (0,styled_components_browser_esm/* css */.iv)(ProductReviews_styles_templateObject2(), globalStyles/* media.largeScreen */.BC.largeScreen(ProductReviews_styles_templateObject()), globalStyles/* media.smallScreen */.BC.smallScreen(ProductReviews_styles_templateObject1()));
var slickPrev = (0,styled_components_browser_esm/* css */.iv)(ProductReviews_styles_templateObject5(), chevron_left, globalStyles/* media.mediumScreen */.BC.mediumScreen(ProductReviews_styles_templateObject3()), globalStyles/* media.smallScreen */.BC.smallScreen(ProductReviews_styles_templateObject4()));
var slickNext = (0,styled_components_browser_esm/* css */.iv)(ProductReviews_styles_templateObject8(), chevron_right, globalStyles/* media.mediumScreen */.BC.mediumScreen(ProductReviews_styles_templateObject6()), globalStyles/* media.smallScreen */.BC.smallScreen(ProductReviews_styles_templateObject7()));
var slickTrack = (0,styled_components_browser_esm/* css */.iv)(ProductReviews_styles_templateObject11(), globalStyles/* media.mediumScreen */.BC.mediumScreen(ProductReviews_styles_templateObject9()), globalStyles/* media.smallScreen */.BC.smallScreen(ProductReviews_styles_templateObject10()));
var slickSlide = (0,styled_components_browser_esm/* css */.iv)(ProductReviews_styles_templateObject12());
var slickList = (0,styled_components_browser_esm/* css */.iv)(ProductReviews_styles_templateObject15(), globalStyles/* media.mediumScreen */.BC.mediumScreen(ProductReviews_styles_templateObject13()), globalStyles/* media.smallScreen */.BC.smallScreen(ProductReviews_styles_templateObject14()));
var styles_Wrapper = globalStyles/* styled.div */.zo.div(ProductReviews_styles_templateObject16(), slickList, slickTrack, slickSlide, slickArrow, slickPrev, slickNext);
var styles_Container = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(ProductReviews_styles_templateObject17());
var styles_Header = globalStyles/* styled.div */.zo.div(styles_templateObject19(), globalStyles/* media.smallScreen */.BC.smallScreen(ProductReviews_styles_templateObject18()));
var ProductReviews_styles_Title = globalStyles/* styled.h2 */.zo.h2(styles_templateObject20(), utils/* pageTitle */.tj);
var styles_Content = globalStyles/* styled.div */.zo.div(styles_templateObject21());
var Slider = globalStyles/* styled.div */.zo.div(styles_templateObject22());
var Slide = globalStyles/* styled.div */.zo.div(styles_templateObject25(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject23()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject24()));
var Link = globalStyles/* styled.a */.zo.a(styles_templateObject27(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject26()), function(props) {
    return props.theme.colors.red;
});

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductReviews/ProductReviews.tsx












// import { structuredDataReview } from '../../../../core/SEO/Product/structuredData';

var ProductReviews = function(param) {
    var reviews = param.reviews;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)([]), activeGallery = ref1[0], setActiveGallery = ref1[1];
    var ref2 = (0,react.useState)(0), activeGalleryIndex = ref2[0], setActiveGalleryIndex = ref2[1];
    var showGallery = function(gallery, index) {
        setActiveGallery(gallery);
        setActiveGalleryIndex(index);
        setShow(true);
    };
    var closeGallery = function() {
        setShow(false);
    };
    var sliderSettings = {
        arrows: true,
        autoplaySpeed: 4000,
        centerMode: true,
        centerPadding: "20px",
        infinite: false,
        responsive: [
            {
                breakpoint: constants/* smallScreen */.xC,
                settings: {
                    adaptiveHeight: true,
                    centerPadding: "40px",
                    swipe: false
                }
            }, 
        ],
        slidesToScroll: 1,
        slidesToShow: 1,
        variableWidth: true
    };
    var slider = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(0), startPos = ref3[0], setStartPos = ref3[1];
    var touchStart = function(e) {
        setStartPos(e.nativeEvent.touches[0].clientX);
    };
    var touchEnd = function(e) {
        var endPos = e.nativeEvent.changedTouches[0].clientX;
        var delta = startPos - endPos;
        var minDeltaValue = 25;
        if (Math.abs(delta) > minDeltaValue && delta > 0) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            slider.current.slickNext();
        }
        if (Math.abs(delta) > minDeltaValue && delta < 0) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            slider.current.slickPrev();
        }
    };
    if ((reviews === null || reviews === void 0 ? void 0 : reviews.length) >= 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGallery/* ImageGallery */.h, {
                    images: activeGallery,
                    index: activeGalleryIndex,
                    show: show,
                    hide: function() {
                        closeGallery();
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Container, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Header, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews_styles_Title, {
                                children: intl.formatMessage({
                                    defaultMessage: "What customers are saying",
                                    id: "QmxCoW"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: paths/* paths.reviews */.H.reviews,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                    children: intl.formatMessage({
                                        defaultMessage: "View all reviews",
                                        id: "d1JKui"
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                        children: (reviews === null || reviews === void 0 ? void 0 : reviews.length) === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem_ReviewItem_ReviewItem, {
                                item: reviews[0],
                                showGallery: showGallery
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onTouchStart: function(e) {
                                return touchStart(e);
                            },
                            onTouchEnd: function(e) {
                                return touchEnd(e);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
                                ref: slider,
                                children: reviews.map(function(e, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem_ReviewItem_ReviewItem, {
                                            item: e,
                                            showGallery: showGallery
                                        })
                                    }, "".concat(e.title, "-").concat(i));
                                })
                            }))
                        })
                    })
                })
            ]
        });
    }
    return null;
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/ProductReviews/index.tsx



/***/ }),

/***/ 708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* reexport */ SliceInspiration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/@prismic/components/PrismicNextImage/index.ts + 3 modules
var PrismicNextImage = __webpack_require__(32243);
// EXTERNAL MODULE: ./src/@prismic/prismic-config.ts + 31 modules
var prismic_config = __webpack_require__(93092);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/images/chevron_left.svg
var chevron_left = __webpack_require__(36811);
// EXTERNAL MODULE: ./src/images/chevron_right.svg
var chevron_right = __webpack_require__(81111);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceInspiration/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 42px;\n      height: 42px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 33px;\n      height: 33px;\n      transform: translate3d(0, 0, 0);\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-arrow {\n    width: 56px;\n    height: 56px;\n    z-index: 3;\n    position: absolute;\n    top: 50%;\n    transform: none;\n    transform: translate(0, -50%);\n    text-indent: -999999px;\n    &:before {\n      content: none;\n    }\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-size: contain !important;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: 30px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: 14px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-prev {\n    background: url(",
        ") no-repeat center !important;\n    background-repeat: no-repeat;\n    left: 65px;\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-size: contain !important;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: 30px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: 14px;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-next {\n    background: url(",
        ") no-repeat center !important;\n    background-repeat: no-repeat;\n    right: 65px;\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      align-items: center;\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-track {\n    display: flex !important;\n    ",
        "\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-slide {\n    padding: 0 10px;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 320px;\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ax-width: 280px;\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 300px;\n      max-height: 380px;\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  width: 100%;\n  margin: 2em 0;\n\n  img {\n    // max-width: 420px;\n    height: 320px;\n    display: block;\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 10px;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}




var slickArrow = (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject1()));
var slickPrev = (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), chevron_left, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject3()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject4()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject5()));
var slickNext = (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), chevron_right, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject7()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject8()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject9()));
var slickTrack = (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject11()));
var slickSlide = (0,styled_components_browser_esm/* css */.iv)(_templateObject13());
var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject17(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject14()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject15()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject16()), slickTrack, slickSlide, slickArrow, slickPrev, slickNext);
var Item = globalStyles/* styled.div */.zo.div(_templateObject19(), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject18()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceInspiration/SliceInspiration.tsx










function removeDomainFromUrl(link) {
    var newUrl = new URL(link.url);
    return {
        __typename: link.__typename,
        _linkType: link._linkType,
        url: newUrl.pathname + newUrl.search
    };
}
var SLYDES_TO_SHOW_DEAFAULT_AMOUNT = 5;
var getSlydesToShowAmount = function(fields) {
    if (fields) {
        return fields.length <= SLYDES_TO_SHOW_DEAFAULT_AMOUNT && fields.length >= 2 ? fields.length - 1 : SLYDES_TO_SHOW_DEAFAULT_AMOUNT;
    }
    return SLYDES_TO_SHOW_DEAFAULT_AMOUNT;
};
function SliceInspiration(param) {
    var fields = param.slice.fields;
    var sliderSettings = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 0,
        dots: false,
        draggable: false,
        infinite: true,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: constants/* smallScreen */.xC,
                settings: {
                    autoplay: false,
                    slidesToShow: 1,
                    speed: 900,
                    swipe: false,
                    swipeToSlide: true
                }
            }, 
        ],
        slidesToScroll: 1,
        slidesToShow: getSlydesToShowAmount(fields),
        speed: 1900,
        variableWidth: true
    };
    var slider = (0,react.useRef)(null);
    var pauseSlider = function() {
        if (window.innerWidth < constants/* smallScreen */.xC) {
            return;
        }
        slider.current.slickPause();
    };
    var playSlider = function() {
        if (window.innerWidth < constants/* smallScreen */.xC) {
            return;
        }
        slider.current.slickPlay();
    };
    var ref = (0,react.useState)(0), startPos = ref[0], setStartPos = ref[1];
    var touchStart = function(e) {
        setStartPos(e.nativeEvent.touches[0].clientX);
    };
    var touchEnd = function(e) {
        var endPos = e.nativeEvent.changedTouches[0].clientX;
        var delta = startPos - endPos;
        var minDeltaValue = 25;
        if (Math.abs(delta) > minDeltaValue && delta > 0) {
            slider.current.slickNext();
        }
        if (Math.abs(delta) > minDeltaValue && delta < 0) {
            slider.current.slickPrev();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "inspiration",
        onMouseEnter: pauseSlider,
        onMouseLeave: playSlider,
        onTouchStart: function(e) {
            return touchStart(e);
        },
        onTouchEnd: function(e) {
            return touchEnd(e);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
            ref: slider,
            children: fields && fields.map(function(item, i) {
                if (item.link && item.link.__typename === "_ExternalLink") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: (0,prismic_config/* linkResolver */.kG)(removeDomainFromUrl(item.link)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                className: "inspiration__item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                    field: item.image,
                                    height: 320,
                                    style: {
                                        maxWidth: "auto",
                                        height: "100%"
                                    },
                                    sizes: "(max-width: 540px) 66vw, (max-width: 1279px) 50vw, 20vw"
                                })
                            })
                        })
                    }, "inspiration__item_".concat(i));
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    className: "inspiration__item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                        field: item.image,
                        height: 320,
                        style: {
                            maxWidth: "auto",
                            height: "100%"
                        }
                    })
                }, "inspiration__item_".concat(i));
            })
        }))
    });
}
SliceInspiration.componentName = "inspiration";
/* harmony default export */ var SliceInspiration_SliceInspiration = ((/* unused pure expression or super */ null && (SliceInspiration)));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceInspiration/index.ts



/***/ }),

/***/ 84057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ SliceInstagramPosts; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
// EXTERNAL MODULE: ./src/images/chevron_left.svg
var chevron_left = __webpack_require__(36811);
// EXTERNAL MODULE: ./src/images/chevron_right.svg
var chevron_right = __webpack_require__(81111);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceInstagramPosts/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-size: contain !important;\n      width: 42px;\n      height: 42px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 33px;\n      width: 33px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      top: 40vw;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-arrow {\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    border-radius: 50%;\n    width: 56px;\n    height: 56px;\n    color: transparent;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.08);\n    z-index: 1;\n    transform: translate3d(0, 0, 0);\n    ",
        "\n    ",
        "\n    ",
        "\n    &:before {\n      content: none;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: 16px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-prev {\n    background: url(",
        ") no-repeat center !important;\n    left: 32px;\n    ",
        "\n    &.slick-disabled {\n      opacity: 0.5;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: 16px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-next {\n    background: url(",
        ") no-repeat center !important;\n    right: 32px;\n    ",
        "\n    &.slick-disabled {\n      opacity: 0.5;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin: 0 -10px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-list {\n    margin: 0 -15px;\n    ",
        "\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2em 2em;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 2rem;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-direction: column;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  margin-bottom: 6px;\n  color: ",
        ";\n  line-height: 1.55em;\n  * {\n    line-height: 1.45em;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1em;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  color: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 85vw;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 87vw;\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 92vw;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 85vw;\n  position: relative;\n  max-width: calc(50vw + 680px);\n  ",
        "\n  ",
        "\n  ",
        "\n\n  .instagram-items-slider__slider {\n    position: static;\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 10px;\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80vw !important;\n  position: relative;\n  max-width: 384px;\n  padding: 0 15px;\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-top: 100%;\n  overflow: hidden;\n  position: relative;\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 10px;\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 17px;\n  background-color: #fff;\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    width: 40px;\n    margin-right: 13px;\n  "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 56px;\n  width: 56px;\n  overflow: hidden;\n  border-radius: 50%;\n  margin-right: 18px;\n  ",
        "\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    padding-top: 0;\n  "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 10px;\n  font-size: ",
        ";\n  color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 10px;\n  "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  display: inline-block;\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}






var slickArrow = (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject1()), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(_templateObject2()));
var slickPrev = (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), chevron_left, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject4()));
var slickNext = (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), chevron_right, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject6()));
var slickList = (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject8()));
var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject10());
var Padding = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject11());
var Header = globalStyles/* styled.div */.zo.div(_templateObject12());
var HeaderTitle = globalStyles/* styled.div */.zo.div(_templateObject13(), utils/* pageTitle */.tj);
var HeaderLink = globalStyles/* styled.div */.zo.div(_templateObject14(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, function(props) {
    return props.theme.colors.red;
});
var HeaderHint = globalStyles/* styled.div */.zo.div(_templateObject15(), function(props) {
    return props.theme.typography.boldFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.blueLight;
});
var Slider = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject19(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject16()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject17()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject18()), slickList, slickArrow, slickPrev, slickNext);
var Item = globalStyles/* styled.div */.zo.div(_templateObject21(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject20()));
var ItemImage = globalStyles/* styled.div */.zo.div(_templateObject22());
var ItemInfo = globalStyles/* styled.div */.zo.div(_templateObject24(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject23()));
var ItemAvatar = globalStyles/* styled.div */.zo.div(_templateObject26(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject25()));
var ItemText = globalStyles/* styled.div */.zo.div(_templateObject28(), function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject27()));
var ItemLink = globalStyles/* styled.span */.zo.span(_templateObject30(), function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.blueLight;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject29()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceInstagramPosts/InstagramHeader.tsx



function InstagramHeader(param) {
    var htitle = param.htitle, user_name = param.user_name, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
        className: "instagram-header",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTitle, {
                className: "instagram-header-title",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                    field: htitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLink, {
                className: "instagram-header-link",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                    field: user_name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderHint, {
                className: "instagram-header-hint",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                    field: text
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
// EXTERNAL MODULE: ./src/@prismic/prismic-config.ts + 31 modules
var prismic_config = __webpack_require__(93092);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceInstagramPosts/InstagramItemsSlider.tsx









function InstagramItemsSlider(param) {
    var itemsList = param.items;
    var sliderSettings = {
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        // speed: 600,
        variableWidth: true,
        responsive: [
            {
                breakpoint: constants/* largeScreen */.M6,
                settings: {
                    slidesToShow: 1,
                    swipeToSlide: true
                }
            },
            {
                breakpoint: constants/* smallScreen */.xC,
                settings: {
                    slidesToShow: 1,
                    swipeToSlide: true
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
        className: "instagram-items-slider",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
            className: "instagram-items-slider__slider",
            children: itemsList === null || itemsList === void 0 ? void 0 : itemsList.map(function(param, i) {
                var image = param.image, post_title = param.post_title, post_user_name = param.post_user_name, user_avatar = param.user_avatar, instagram_link = param.instagram_link;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: (0,prismic_config/* linkResolver */.kG)(instagram_link),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                            className: "instagram-items-slider__item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemImage, {
                                    className: "instagram-items-slider__item-image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: image.url,
                                        width: 360,
                                        height: 360,
                                        loading: "lazy",
                                        alt: "...",
                                        style: {
                                            maxWidth: "auto",
                                            height: "100%"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemInfo, {
                                    className: "instagram-items-slider__item-info",
                                    children: [
                                        user_avatar && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemAvatar, {
                                            className: "instagram-items-slider__item-avatar-wr",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "instagram-items-slider__item-avatar",
                                                src: user_avatar.url,
                                                alt: "instagram avatar"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemText, {
                                            className: "instagram-items-slider__item-text",
                                            children: [
                                                post_title && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                                    field: post_title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemLink, {
                                                    className: "instagram-items-slider__item-link",
                                                    children: typeof post_user_name === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: post_user_name
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                                        field: post_user_name
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, i)
                    })
                }, "instagram-link-".concat(i));
            })
        }))
    });
}

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceInstagramPosts/InstagramItemsEmbed.tsx







var appId = "375904594550341";
var clientToken = "59ecf2ad2697b5e10a54d85c64097bdc";
var clientAccessToken = "".concat(appId, "|").concat(clientToken);
var getInstagramEmbed = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
        var response, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch("https://graph.facebook.com/v14.0/instagram_oembed?url=".concat(url, "&fields=thumbnail_url,author_name&access_token=").concat(clientAccessToken))
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            url: url
                        })
                    ];
                case 3:
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    console.error("error: ", error);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function getInstagramEmbed(url) {
        return _ref.apply(this, arguments);
    };
}();
function InstagramItemsEmbed(param) {
    var postUrls = param.postUrls;
    var ref = (0,react.useState)([]), embedPosts = ref[0], setEmbedPosts = ref[1];
    (0,react.useEffect)(function() {
        if (postUrls) {
            var getInstagramEmbedPosts = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var postsData, filteredPostData;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(postUrls.map(getInstagramEmbed))
                                ];
                            case 1:
                                postsData = _state.sent();
                                filteredPostData = [];
                                postsData.forEach(function(post) {
                                    if (post) {
                                        filteredPostData.push(post);
                                    }
                                });
                                setEmbedPosts(filteredPostData);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function getInstagramEmbedPosts() {
                    return _ref.apply(this, arguments);
                };
            }();
            getInstagramEmbedPosts();
        }
    }, [
        postUrls
    ]);
    var instagramStaticItems = (0,react.useMemo)(function() {
        return embedPosts.map(function(post) {
            return {
                image: {
                    url: post.thumbnail_url
                },
                instagram_link: {
                    url: post.url
                },
                post_user_name: "@".concat(post.author_name)
            };
        });
    }, [
        embedPosts
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InstagramItemsSlider, {
        items: instagramStaticItems
    });
}

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceInstagramPosts/SliceInstagramPosts.tsx






function SliceInstagramPosts(param) {
    var _slice = param.slice, primary = _slice.primary, fields = _slice.fields;
    var postUrls = (0,react.useMemo)(function() {
        return fields === null || fields === void 0 ? void 0 : fields.map(function(f) {
            var ref;
            return f === null || f === void 0 ? void 0 : (ref = f.instagram_link) === null || ref === void 0 ? void 0 : ref.url;
        });
    }, [
        fields === null || fields === void 0 ? void 0 : fields.map
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "instagram-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Padding, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InstagramHeader, (0,_object_spread/* default */.Z)({}, primary)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InstagramItemsEmbed, {
                    postUrls: postUrls
                })
            ]
        })
    });
}
SliceInstagramPosts.componentName = "instagram_posts";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceInstagramPosts/index.ts



/***/ }),

/***/ 44610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rv": function() { return /* binding */ paddingLeft; },
  "tj": function() { return /* binding */ pageTitle; },
  "C7": function() { return /* binding */ prismicRichText; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/images/title-top.svg
var title_top = __webpack_require__(43157);
;// CONCATENATED MODULE: ./src/images/title-top-blue.svg
var title_top_blue_namespaceObject = __webpack_require__.p + "static/images/title-top-blue.svg";
// EXTERNAL MODULE: ./src/@next/globalStyles/media.ts
var media = __webpack_require__(59390);
;// CONCATENATED MODULE: ./src/@next/globalStyles/utils.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 25px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 0;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 64px;\n        left: -25px;\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 35px;\n        left: -15px;\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 30px 0 0;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 15px 0 0;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    font-size: ",
        ";\n    font-family: ",
        ";\n    line-height: 1em;\n    font-weight: lighter;\n    color: ",
        ";\n    letter-spacing: -0.5px;\n    padding: 40px 0 0;\n    &:before {\n      content: '';\n      display: block;\n      position: absolute;\n      left: -44px;\n      top: 0;\n      width: 92px;\n      height: 15px;\n      background: url(",
        ") no-repeat left top;\n      background-size: contain;\n      ",
        "\n      ",
        "\n    }\n    &.blue {\n      &:before {\n        background: url(",
        ") no-repeat left top;\n        background-size: contain;\n      }\n    }\n    ",
        "\n    ",
        "\n    * {\n      font: inherit;\n    }\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          top: 15px;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          top: 12px;\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h1,\n  h2,\n  h3,\n  h4 {\n    font-size: ",
        ";\n    font-family: ",
        ";\n    line-height: 110%;\n    margin-bottom: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  h5,\n  h6 {\n    font-size: ",
        ";\n    font-family: ",
        ";\n    line-height: 140%;\n    margin-bottom: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  p {\n    font-size: ",
        ";\n    font-family: ",
        ";\n    color: ",
        ";\n    line-height: 180%;\n    margin-bottom: ",
        ";\n  }\n\n  a {\n    text-decoration: underline;\n    color: ",
        ";\n  }\n\n  b {\n    font-weight: 600;\n  }\n\n  strong {\n    color: ",
        ";\n  }\n\n  i {\n    font-style: italic;\n  }\n\n  & em {\n    color: ",
        ";\n  }\n\n  ul,\n  ol {\n    margin-bottom: ",
        ";\n\n    li {\n      font-size: ",
        ";\n      font-family: ",
        ";\n      line-height: 220%;\n      color: ",
        "; // #666f73;\n    }\n  }\n\n  ul {\n    li {\n      padding-left: 24px;\n      position: relative;\n\n      &:before {\n        content: '';\n        display: block;\n        background-color: ",
        ";\n        width: 6px;\n        height: 6px;\n        border-radius: 50%;\n        position: absolute;\n        left: 0;\n        top: 17px;\n\n        ",
        "\n        ",
        "\n      }\n    }\n  }\n\n  ol {\n    list-style: inside;\n    list-style-type: decimal;\n  }\n\n  &.text-center * {\n    text-align: center;\n  }\n\n  &.text-right * {\n    text-align: right;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var paddingLeft = (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), function(param) {
    var theme = param.theme;
    return "".concat(theme.container.paddingLeft, "px");
}, media/* media.mediumScreen */.B.mediumScreen(_templateObject()), media/* media.smallScreen */.B.smallScreen(_templateObject1()));
var pageTitle = (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), function(props) {
        return props.theme.typography.h2FontSize;
    }, function(props) {
        return props.theme.typography.thinFontFamily;
    }, theme.colors.baseFont, title_top, media/* media.largeScreen */.B.largeScreen(_templateObject3()), media/* media.smallScreen */.B.smallScreen(_templateObject4()), title_top_blue_namespaceObject, media/* media.largeScreen */.B.largeScreen(_templateObject5()), media/* media.smallScreen */.B.smallScreen(_templateObject6()));
});
var prismicRichText = (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), function(props) {
    return props.theme.typography.h3FontSize;
}, function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h2FontSize;
}, function(props) {
    return props.theme.typography.h2FontSize;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h3FontSize;
}, function(props) {
    return props.theme.typography.h1FontSize;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.colors.graySemi;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, function(props) {
    return props.theme.colors.blueLight;
}, function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.colors.graySemi;
}, function(props) {
    return props.theme.colors.red;
}, media/* media.largeScreen */.B.largeScreen(_templateObject9()), media/* media.smallScreen */.B.smallScreen(_templateObject10()));


/***/ }),

/***/ 32243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PrismicNextImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/@prismicio/client/dist/helpers/isFilled.js
var isFilled = __webpack_require__(66686);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/buildURL.ts
/**
 * Converts a camel case string to a param case string.
 *
 * @example
 *
 * ```ts
 * camelCaseToParamCase("fooBar");
 * // => 'foo-bar'
 * ```
 *
 * @param input - Camel case string to convert.
 *
 * @returns Param case version of `input`.
 */ var camelCaseToParamCase = function(input) {
    return input.replace(/[A-Z]/g, function(match) {
        return "-".concat(match.toLowerCase());
    });
};
/**
 * Builds a URL to an Imgix image with Imgix URL API parameters.
 *
 * The given URL must be a full absolute URL containing the protocol and domain.
 *
 * URL parameters already applied to the image will be retained. To remove
 * existing parameters, set the parameter to `undefined` in the `params` argument.
 *
 * @example
 *
 * ```ts
 * const url = buildURL("https://example.imgix.net/image.png", {
 * 	width: 400,
 * });
 * // => https://example.imgix.net/image.png?width=400
 * ```
 *
 * @example
 *
 * ```ts
 * const url = buildURL("https://example.imgix.net/image.png?width=400", {
 * 	height: 300,
 * });
 * // => https://example.imgix.net/image.png?width=400&height=300
 * ```
 *
 * @param url - Full absolute URL to the Imgix image.
 * @param params - An object of Imgix URL API parameters.
 *
 * @returns `url` with the given Imgix URL API parameters applied.
 *
 * @see Imgix URL API reference: https://docs.imgix.com/apis/rendering
 */ var buildURL = function(url, params) {
    var instance = new URL(url);
    Object.keys(params).forEach(function(camelCasedParamKey) {
        var paramKey = camelCaseToParamCase(camelCasedParamKey);
        var paramValue = params[camelCasedParamKey];
        if (paramValue === undefined) {
            instance.searchParams.delete(paramKey);
        } else if (Array.isArray(paramValue)) {
            instance.searchParams.set(paramKey, paramValue.join(","));
        } else {
            instance.searchParams.set(paramKey, "".concat(paramValue));
        }
    });
    // Ensure the `s` parameter is the last parameter, if it exists.
    // @see https://github.com/imgix/imgix-blueprint#securing-urls
    var s = instance.searchParams.get("s");
    if (s) {
        instance.searchParams.delete("s");
        instance.searchParams.append("s", s);
    }
    return instance.toString();
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/buildWidthSrcSet.ts




/**
 * Builds an `<img>` `srcset` attribute value for a given set of widths. It can
 * also optinally apply Imgix URL API parameters to the URLs.
 *
 * The `width` URL parameter will be applied for each `srcset` entry. If a
 * `width` or `w` parameter is provided to the `params` parameter, it will be ignored.
 *
 * @example
 *
 * ```ts
 * const srcset = buildWidthSrcSet('https://example.imgix.net/image.png', {
 * 	widths: [400, 800, 1600],
 * });
 * // => https://example.imgix.net/image.png?width=400 400w,
 * //    https://example.imgix.net/image.png?width=800 800w,
 * //    https://example.imgix.net/image.png?width=1600 1600w
 * ```
 *
 * @example
 *
 * ```ts
 * const srcset = buildWidthSrcSet('https://example.imgix.net/image.png', {
 * 	widths: [400, 800, 1600],
 * 	sat: -100,
 * });
 * // => https://example.imgix.net/image.png?width=400&sat=-100 400w,
 * //    https://example.imgix.net/image.png?width=800&sat=-100 800w,
 * //    https://example.imgix.net/image.png?width=1600&sat=-100 1600w
 * ```
 *
 * @param url - Full absolute URL to the Imgix image.
 * @param params - An object of Imgix URL API parameters. The `widths` parameter
 *   defines the resulting `srcset` widths.
 *
 * @returns A `srcset` attribute value for `url` with the given Imgix URL API
 *   parameters applied.
 */ var buildWidthSrcSet = function(url, _param) {
    var widths = _param.widths, params = (0,_object_without_properties/* default */.Z)(_param, [
        "widths"
    ]);
    return widths.map(function(width) {
        return "".concat(buildURL(url, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
            w: undefined,
            width: width
        })), " ").concat(width, "w");
    }).join(", ");
};

;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/PrismicNextImage.tsx
/* eslint-disable */ 







var castInt = function(input) {
    if (typeof input === "number" || typeof input === "undefined") {
        return input;
    }
    var parsed = Number.parseInt(input, 10);
    if (Number.isNaN(parsed)) {
        return undefined;
    }
    return parsed;
};
/**
 * Creates a `next/image` loader for Imgix, which Prismic uses, with an optional
 * collection of default Imgix parameters.
 *
 * @see To learn about `next/image` loaders: https://nextjs.org/docs/api-reference/next/image#loader
 * @see To learn about Imgix's URL API: https://docs.imgix.com/apis/rendering
 */ var imgixLoader = function(args) {
    var url = new URL(args.src);
    var params = {
        auto: url.searchParams.getAll("auto") || [
            "format", 
        ],
        fit: url.searchParams.get("fit") || "max",
        w: args.width,
        h: undefined
    };
    if (args.quality) {
        params.q = args.quality;
    }
    return buildURL(args.src, params);
};
/**
 * React component that renders an image from a Prismic Image field or one of
 * its thumbnails using `next/image`. It will automatically set the `alt`
 * attribute using the Image field's `alt` property.
 *
 * It uses an Imgix URL-based loader by default. A custom loader can be provided
 * with the `loader` prop. If you would like to use the Next.js Image
 * Optimization API instead, set `loader={undefined}`.
 *
 * @param props - Props for the component.
 *
 * @returns A responsive image component using `next/image` for the given Image
 *   field.
 * @see To learn more about `next/image`, see: https://nextjs.org/docs/api-reference/next/image
 */ var PrismicNextImage = function(_param) {
    var field = _param.field, _imgixParams = _param.imgixParams, imgixParams = _imgixParams === void 0 ? {} : _imgixParams, alt = _param.alt, fallbackAlt = _param.fallbackAlt, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "field",
        "imgixParams",
        "alt",
        "fallbackAlt"
    ]);
    if (typeof alt === "string" && alt !== "") {
        console.warn('[PrismicNextImage] The "alt" prop can only be used to declare an image as decorative by passing an empty string (alt="") but was provided a non-empty string. You can resolve this warning by removing the "alt" prop or changing it to alt="".');
    }
    if (typeof fallbackAlt === "string" && fallbackAlt !== "") {
        console.warn('[PrismicNextImage] The "fallbackAlt" prop can only be used to declare an image as decorative by passing an empty string (fallbackAlt="") but was provided a non-empty string. You can resolve this warning by removing the "fallbackAlt" prop or changing it to fallbackAlt="".');
    }
    if (isFilled/* imageThumbnail */.S$(field)) {
        var src = buildURL(field.url, imgixParams);
        var url = new URL(src);
        var mediaUrl = new URL("https://images.renodoors.eu/");
        url.hostname = mediaUrl.hostname;
        var ar = field.dimensions.width / field.dimensions.height;
        var resolvedWidth = field.dimensions.width;
        var resolvedHeight = field.dimensions.height;
        if ("width" in restProps || "height" in restProps) {
            var castedWidth = castInt(restProps.width);
            var castedHeight = castInt(restProps.height);
            if (castedWidth) {
                resolvedWidth = castedWidth;
            } else if (castedHeight) {
                resolvedWidth = ar * castedHeight;
            }
            resolvedHeight = resolvedWidth / ar;
        }
        var mobileSrcSet = field["mobile"] ? buildWidthSrcSet(field["mobile"].url, {
            widths: [
                constants/* smallScreen */.xC,
                2 * constants/* smallScreen */.xC
            ]
        }) : null;
        var tabletSrcSet = field["tablet"] ? buildWidthSrcSet(field["tablet"].url, {
            widths: [
                constants/* mediumScreen */.M7,
                2 * constants/* mediumScreen */.M7
            ]
        }) : null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
            children: [
                mobileSrcSet && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    media: "(max-width: ".concat(constants/* smallScreen */.xC, "px)"),
                    srcSet: mobileSrcSet
                }),
                tabletSrcSet && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    media: "(max-width: ".concat(constants/* mediumScreen */.M7, "px)"),
                    srcSet: tabletSrcSet
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({
                    src: url.href,
                    width: resolvedWidth,
                    height: resolvedHeight,
                    alt: alt !== null && alt !== void 0 ? alt : field.alt || fallbackAlt,
                    loader: imgixLoader
                }, restProps))
            ]
        });
    }
    return null;
};

;// CONCATENATED MODULE: ./src/@prismic/components/PrismicNextImage/index.ts



/***/ }),

/***/ 36811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/chevron_left.svg";

/***/ }),

/***/ 81111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/chevron_right.svg";

/***/ }),

/***/ 43157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/title-top.svg";

/***/ })

}]);